<template>
  <div class="white-page" >
    <div class="tool">
        <template v-if="pageFunc.includes('add')">
            <el-button type="primary" icon="el-icon-plus" @click="handleAddFileSeparateQueue">添加文件</el-button> 
            <span class="slice" v-if="showBatchOpt">|</span> 
        </template>
        <template  v-if="showBatchOpt">
            <el-dropdown
                :disabled="!selectData.length"
                @command="handleCommand"
            >
                <el-button >
                    批量编辑<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="pageFunc.includes('del')" command="delete" icon="el-icon-delete">
                        删除
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <span class="select-num">已选中 {{ selectData.length }} 条</span>
        </template>
    </div>
    <el-table
        :data="list"
        border
        style="width: 100%"
        tooltip-effect="dark"
        :header-cell-style="{background:'#e8eaec',color:'#333'}"
        stripe
        class="mt10"
        v-loading="loading"
        @selection-change="handleSelectionChange"
    >
        <el-table-column
            type="selection"
            width="55"
            v-if="showBatchOpt"
        />
        <el-table-column
            prop="task_number"
            label="任务编号"
            width="100"
        />
        <el-table-column
            prop="task_name"
            label="任务名称"
            min-width="200"
        />
        <el-table-column
            prop="daily_file_name"
            label="文件名称"
            min-width="200"
        />
        <el-table-column
            prop="task_creator_name"
            label="任务归属人"
            min-width="120"
        />
        <el-table-column
            prop="creator_name"
            label="创建人"
            min-width="100"
        />
        <el-table-column
            prop="create_time"
            label="创建时间"
            min-width="120"
        />
        <el-table-column
            prop="date"
            label="操作"
            fixed="right"
            width="100"
        >
             <template slot-scope="{ row }">
                <el-button v-if="pageFunc.includes('del')" type="text" :disabled="row.loading" @click="handleDel([row])" style="color: red;">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
        class="tac mt20"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pn"
        :page-sizes="[100, 200, 500]"
        :page-size="pagination.rn"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { getFileSeparateQueueListApi, delFileSeparateQueueItemApi, addFileSeparateQueueItemApi } from '@/api/efficiencyTool/config'
import { addFileSeparateQueueeDialog } from "./modal"
export default {
    name: "ConfigOnlyList",
    props: ['pageFunc'],
    data() {
        return {
            list: [],
            selectData: [],
            pagination: {//分页信息
                pn: 1,
                rn: 100
            },
            total: 0,
            loading: false
        }
    },
    created() {
        this.getFileSeparateQueueList()
    },
    computed: {
        // 是否要显示批量操作
        showBatchOpt() {
            return ['del'].some((key)=> {
                return this.pageFunc.includes(key)
            })
        }
    },
    methods: {
        handleCommand(key) {
            switch (key) {
                case 'delete':
                    this.handleDel([...this.selectData]).then(()=> {
                        this.selectData = []
                    })
                    break;
                default:
                    break;
            }
            console.log(key);
        },
        // 添加
        handleAddFileSeparateQueue() {
            const onSubmit = async (data, cb)=> {
                try {
                    await addFileSeparateQueueItemApi({ ...data });
                    this.$message.success('添加成功')
                    this.pagination.pn = 1
                    this.getFileSeparateQueueList()
                    vm.close()
                } catch (error) {
                    if (error.data?.length> 0) {
                        const list = error.data.map(v=>v.err_file);
                        const msgList = error.data.map(v=>v.err_msg);
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>以下文件存在问题，请核实，是否需要剔除有问题的文件?</p>';
                        htmlStr += '<p class="font12px">'+(msgList.join('<br/>'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            width:'500',
                        }).then(()=>{
                            cb(data.file_list.filter(v=>!list.includes(v)))
                        });
                    }else {
                        this.$message.error(error.info)
                    }
                }finally {
                    cb()
                }
            }
            const { vm } = addFileSeparateQueueeDialog({
                cbs: {
                    onSubmit
                }
            })
        },
        // 删除 Rw62
        handleDel(rows) {
            return new Promise((resolve, reject)=> {
                 this.$confirm(`是否删除?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                }).then(async () => {
                    try {
                        rows.map(v=> v.loading = true);
                        const params = {
                            detail_id: rows.map(v=> v.detail_id)
                        }
                        await delFileSeparateQueueItemApi(params);
                        resolve()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    } catch (error) {
                        this.$message.error(error.info)
                        rows.map(v=> v.loading = false);
                        reject()
                    } finally {
                        const { pn } = this.pagination;
                        if (pn !==1 &&  rows.length >= this.list) {
                        this.pagination.pn = pn - 1
                        }
                    this.getFileSeparateQueueList()
                    }
                }).catch(() => {
                    reject()
                });
            })
           
        },
        // 获取列表
        async getFileSeparateQueueList() {
            this.loading = true
            try {
                const { data } = await getFileSeparateQueueListApi({
                    ...this.pagination
                });
                this.list = data.list.map(v=> {
                    return {
                        ...v,
                        loading: false
                    }
                })
                this.total = data.totalCnt
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        handleSelectionChange(data) {
            this.selectData = data
        },
        handleSizeChange(rn) {
            this.pagination.rn = rn;
            this.pagination.pn = 1;
            this.getFileSeparateQueueList()
        },
        handleCurrentChange(pn) {
            this.pagination.pn = pn;
            this.getFileSeparateQueueList()
        }
    }
}
</script>

<style lang="scss" scoped>
.white-page {
    .tool {
         .slice {
            padding: 0 10px;
        }
        .select-num {
            padding-left: 10px;
            color: #bbb;
        }
    }
   
}
</style>